"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PillGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _Pill = require("./Pill");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PillGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(PillGroup, _React$Component);
  var _super = _createSuper(PillGroup);
  function PillGroup(props) {
    var _this;
    _classCallCheck(this, PillGroup);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "renderPill", function () {
      var items = _this.state.initialItems;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: _this.props.id,
        className: _this.props.className
      }, items !== undefined && items.length > 0 && items.map(function (element, index) {
        var variant = element.variant;
        var events = {};
        if (variant === 'input') {
          events = _objectSpread(_objectSpread({}, events), {}, {
            onCancel: _this.handleCancel
          });
        } else {
          events = _objectSpread(_objectSpread({}, events), {}, {
            onClick: _this.handleClick
          });
        }
        return /*#__PURE__*/_react.default.createElement(_Pill.Pill, _extends({
          label: element.label,
          id: element.id,
          key: index,
          labelLengthTruncated: element.labelLengthTruncated,
          isActive: element.isActive,
          variant: variant,
          index: index,
          className: element.className,
          isDisabled: element.isDisabled
        }, events));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "handleCancel", function (e, data) {
      _this.props.onCancel && _this.props.onCancel(e, data);
    });
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      initialItems: [],
      activeItems: []
    };
    return _this;
  }
  _createClass(PillGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var initialItemsTemp = _toConsumableArray(this.props.items);
      var variant = this.props.variant;
      var activeItemsTemp = initialItemsTemp.filter(function (element) {
        return element.isActive === true;
      });
      if (this.props.onClick) this.props.onClick(initialItemsTemp, activeItemsTemp, variant);
      this.setState({
        initialItems: initialItemsTemp,
        activeItems: activeItemsTemp
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderPill());
    }
  }, {
    key: "handleClick",
    value: function handleClick(index, e) {
      var initialItemsTemp = _toConsumableArray(this.state.initialItems);
      var variant = this.props.variant;
      if (!initialItemsTemp[index].isDisabled) {
        var changingIndex = _objectSpread({}, initialItemsTemp[index]);
        changingIndex.isActive = !changingIndex.isActive;
        initialItemsTemp[index] = changingIndex;
      }
      var activeItemsTemp = initialItemsTemp.filter(function (element) {
        return element.isActive === true;
      });
      var clickedItem = initialItemsTemp[index];
      if (this.props.onClick) this.props.onClick(initialItemsTemp, activeItemsTemp, variant, e, clickedItem);
      if (!e.defaultPrevented) {
        this.setState({
          initialItems: initialItemsTemp,
          activeItems: activeItemsTemp
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.initialItems !== props.items) {
        return {
          initialItems: props.items
        };
      }
      return null;
    }
  }]);
  return PillGroup;
}(_react.default.Component);
exports.PillGroup = PillGroup;